import React, { useState, useEffect } from "react";

import Autocomplete from "../ui/Autocomplete";
import NuxeoClient from "../../clients/NuxeoClient";

import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import InputLabel from "@material-ui/core/InputLabel";

import { useI18n } from "../../I18nProvider";

export default function OriginalAssetSeason(props) {
  const appText = useI18n();
  const [isLoading, setIsLoading] = useState(false);
  const [fetchedData, setFetchedData] = useState([]);

  useEffect(() => {
    if (props.propertyID) {
      setIsLoading(true);
      _loadOriginalSeasons();
    }
  }, [props.propertyID]);

  async function _loadOriginalSeasons() {
    await NuxeoClient.instance()
      .fetchOriginalSeasons(props.propertyID)
      .then((response) => {
        if (response.entries.length > 0) {
          setFetchedData(response.entries);
        }
        setIsLoading(false);
      });
  }

  const handleChange = (originalSeason) => {
    if (originalSeason !== null) {
      let value = originalSeason[originalSeason.length - 1];
      props.handleChange("originalSeason", value.label);
      props.handleChange("originalAssetSeasonID", value.id);
    } else {
      props.handleChange("originalSeason", "");
      props.handleChange("originalAssetSeasonID", null);
    }
  };

  return (
    // <Tooltip arrow title="Please, select the original asset seaons">
    <Tooltip arrow title={appText.T131}>
      <Grid item={true} xs={12}>
        <div id="assetFileName">
          <InputLabel className="field-label field-dropdown">
            {/* Original Asset Season */}
            {appText.T83}
          </InputLabel>
          <Autocomplete
            type={"single"}
            handleChange={handleChange}
            data={fetchedData}
            dataType={"originalSeason"}
            mapVariable={"title"}
            setFilterData={() => null}
            value={props.value}
            isLoading={isLoading}
            isNotRequired={true}
          />
        </div>
      </Grid>
    </Tooltip>
  );
}
